'use client';

import { ComponentErrorBoundary, HomeComponent } from '@/components';
import { useHome } from '@/hooks';

export const HomeContainer = () => {
  const homeData = useHome();

  return (
    <ComponentErrorBoundary componentName="Home Container">
      <HomeComponent homeData={homeData} />
    </ComponentErrorBoundary>
  );
};
